import React from "react";
import classes from "./Modal.module.css";

import sadFace from "../../pics/noto_sad-but-relieved-face.svg";

import { connect } from "react-redux";

const Modal = ({
  isModal,
  modalContent,
}: {
  isModal: boolean;
  modalContent: string;
}) => {
  return (
    <div
      style={
        isModal ? { zIndex: 10000, opacity: 1 } : { zIndex: -10000, opacity: 0 }
      }
      className={classes.Modal}
    >
      <div className={classes.Modal_content}>
        {modalContent === "finish" ? (
          <div className={classes.Modal_content_text}>
            <h3>La tua prenotazione è stata completata con successo.</h3>
            <div className={classes.Modal_content_text_styled}>
              <h3>Stiamo aspettando la tua visita :)</h3>
            </div>
          </div>
        ) : (
          <div className={classes.Modal_content_text}>
            <img
              src={sadFace}
              alt="sad face"
              style={{ display: "block", margin: "0 auto" }}
            />
            <h3>La sessione sta scadendo.</h3>
            <div className={classes.Modal_content_text_styled}>
              <h3>Riprova</h3>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

interface IObject {
  isModal: boolean;
  modalContent: string;
}

function mapStateToProps(state: IObject) {
  return {
    isModal: state.isModal,
    modalContent: state.modalContent,
  };
}

export default connect(mapStateToProps)(Modal);
